type FromLocation = { pathname?: unknown; search?: unknown; hash?: unknown };

const BLOCKED_PATHS = new Set(['/login']);

export function returnPathFrom(state: unknown, fallback = '/'): string {
  const from = (state as { from?: FromLocation } | null | undefined)?.from;
  const pathname = from?.pathname;
  if (typeof pathname !== 'string') return fallback;
  if (!pathname.startsWith('/') || pathname.startsWith('//') || pathname.startsWith('/\\')) return fallback;
  if (BLOCKED_PATHS.has(pathname)) return fallback;
  const search = typeof from?.search === 'string' ? from.search : '';
  const hash = typeof from?.hash === 'string' ? from.hash : '';
  return `${pathname}${search}${hash}`;
}
